import { useCallback } from 'react';
import { useLocalStorageState } from './useLocalStorageState';

export interface RecentItem {
  type: 'incident' | 'vehicle' | 'recommendation' | 'policy';
  id: string;
  label: string;
  path: string;
  at: number;
}

const KEY = 'oip.recentItems';
const MAX = 8;

/** Tracks recently viewed detail records for the command palette. */
export function useRecentItems() {
  const [items, setItems] = useLocalStorageState<RecentItem[]>(KEY, []);
  const push = useCallback(
    (item: Omit<RecentItem, 'at'>) => {
      setItems((prev) => {
        const next = [{ ...item, at: Date.now() }, ...prev.filter((p) => p.path !== item.path)];
        return next.slice(0, MAX);
      });
    },
    [setItems],
  );
  return { items, push };
}
